// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"SubscriptionList_tableHeader_1gMDp","dropdownContainer":"SubscriptionList_dropdownContainer_tWTjT","elipseColor":"SubscriptionList_elipseColor_MpFh6"};